module.exports = __webpack_public_path__ + "media/images/sales/set/eyecatch-set-01-f5bb3513e8c91624275fc57df7a63f99.svg";